import { PADDLE_PRICE_IDS, PLANS_CHECKOUT_PRICE_IDS } from "./local-price-ids";
import { isDevEnvironment } from "./misc";
import { baseUrl, PADDLE_DISCOUNT_IDS } from "./variables";

const IS_DEV = isDevEnvironment();

export const DYNAMIC_ANNUAL_PRICE_IDS = IS_DEV
  ? {
      99.99: {
        trialDescription: "price_1R6xvoLvyjRKGUTX09q5TrlP",
        noTrialDescription: "price_1QZdSpLvyjRKGUTXTj1xpGWz",
      },
      120.0: {
        trialDescription: "price_1RoR4QLvyjRKGUTXvuzBmv9M",
        noTrialDescription: "price_1RoR4QLvyjRKGUTXvuzBmv9M",
      },
      124.99: {
        trialDescription: "price_1R6y2OLvyjRKGUTXVQyceDEz",
        noTrialDescription: "price_1QZdSpLvyjRKGUTXTtOpuhKL",
      },
      1: {
        trialDescription: "price_1RoR1xLvyjRKGUTXPO5taxqU",
        noTrialDescription: "price_1RoR1xLvyjRKGUTXPO5taxqU",
      },
    }
  : {
      99.99: {
        trialDescription: "price_1ROKs2LvyjRKGUTXLYyMhfum",
        noTrialDescription: "price_1R7I3LLvyjRKGUTXewKnS6wZ",
      },
      120.0: {
        trialDescription: "price_1RoQvBLvyjRKGUTXKMmFf9CN",
        noTrialDescription: "price_1RoQvBLvyjRKGUTXKMmFf9CN",
      },
      124.99: {
        trialDescription: "price_1Pqn4BLvyjRKGUTXFzFNdPM4",
        noTrialDescription: "price_1ROKwHLvyjRKGUTXU4QFOALZ",
      },
      1: {
        trialDescription: "price_1RoQs6LvyjRKGUTXAueBnybv",
        noTrialDescription: "price_1RoQs6LvyjRKGUTXAueBnybv",
      },
    };

export const DYNAMIC_GIFT_PRICE_IDS = IS_DEV
  ? {
      124.99: "price_1RGra6LvyjRKGUTXTE6YBUln",
      99.99: "price_1RGrV0LvyjRKGUTXwMoUpDPn",
    }
  : {
      124.99: "price_1QICWyLvyjRKGUTXOJUpQxDs",
      99.99: "price_1QSm6ALvyjRKGUTX8WufWny5",
    };

export const DYNAMIC_GIFT_REDEMPTION_PRICE_IDS = IS_DEV
  ? {
      124.99: "price_1RH2dELvyjRKGUTXT4JDfTGN",
    }
  : {
      124.99: "price_1RQTh0LvyjRKGUTX3RG8Tuc1",
    };

export const BIMONTHLY_PRICE_IDS = IS_DEV
  ? {
      39.99: "price_1RY6KXLvyjRKGUTXjuFE6pnW",
    }
  : {
      39.99: "price_1RY60LLvyjRKGUTXkkbou6t4",
    };

export const COUPON_IDS = IS_DEV
  ? {
      percent20: "FqNIqhiv",
      percent30: "ZSi4Pg2A",
      percent40: "48IbJfVP",
      percent40ImprintSub: "48IbJfVP",
      percent50: "I2w6AgP0",
      percent60: "kNcvfejP",
    }
  : {
      percent20: "isCGebHx",
      percent30: "ys0w8LBi",
      percent40: "fCcgdGpP",
      percent40ImprintSub: "WfSv8VpF",
      percent50: "6mEuMjZb",
      percent60: "4neLyjiW",
    };

type FlowPriceT = {
  cost: number;
  priceId: string;
  paddlePriceId?: string;
  coupon?: { amount: number; id: string; paddleId: string };
  trial: boolean;
  cancelUrl: string;
  successUrl: string;
  startDate?: Date;
  endDate?: Date;
};

// Add new flows types here for regular flows or AB tests
export type FlowKeys =
  | "web_no_trial"
  | "email"
  | "startnow"
  | "presidentsdayweb2025"
  | "appjuly2025"
  | "webjuly2025"
  | "direct_pay_monthly"
  | "direct_pay_quarterly"
  | "direct_pay_annual"
  | "gift_purchase"
  | "gift_redeem"
  | "buddhism"
  | "buddhism_test_route"
  | "default";
export const FLOW_PRICE_MAP: Record<FlowKeys, FlowPriceT> = {
  web_no_trial: {
    cost: 124.99,
    priceId: DYNAMIC_ANNUAL_PRICE_IDS[124.99].noTrialDescription,
    paddlePriceId: PADDLE_PRICE_IDS.trial[124.99],
    coupon: { amount: 20, id: COUPON_IDS.percent20, paddleId: PADDLE_DISCOUNT_IDS[20] },
    trial: false,
    cancelUrl: `${baseUrl}/special-offer`,
    successUrl: `${baseUrl}/special-offer/complete`,
  },
  // web_paid_trial: {
  //   cost: 39.99,
  //   priceId: "price_1RY60LLvyjRKGUTXkkbou6t4", // bi-weekly price id
  //   trial: true,
  //   cancelUrl: `${baseUrl}/special-offer`,
  //   successUrl: `${baseUrl}/special-offer/complete`,
  // },
  email: {
    cost: 124.99,
    priceId: DYNAMIC_ANNUAL_PRICE_IDS[124.99].noTrialDescription,
    paddlePriceId: PADDLE_PRICE_IDS.no_trial[124.99],
    coupon: { amount: 30, id: COUPON_IDS.percent30, paddleId: PADDLE_DISCOUNT_IDS[30] },
    trial: false,
    cancelUrl: `${baseUrl}/offer/go`,
    successUrl: `${baseUrl}/subscription/create-account/complete`,
  },
  startnow: {
    cost: 124.99,
    priceId: DYNAMIC_ANNUAL_PRICE_IDS[124.99].noTrialDescription,
    paddlePriceId: PADDLE_PRICE_IDS.no_trial[124.99],
    coupon: { amount: 50, id: COUPON_IDS.percent50, paddleId: PADDLE_DISCOUNT_IDS[50] },
    trial: false,
    cancelUrl: `${baseUrl}/special-offer`,
    successUrl: `${baseUrl}/special-offer/complete`,
  },
  direct_pay_monthly: {
    cost: 23.99,
    priceId: PLANS_CHECKOUT_PRICE_IDS[23.99],
    paddlePriceId: PADDLE_PRICE_IDS.no_trial[23.99],
    coupon: { amount: 50.01, id: COUPON_IDS.percent50, paddleId: PADDLE_DISCOUNT_IDS[50] },
    trial: false,
    cancelUrl: `${baseUrl}/signup/special-offer/plans`,
    successUrl: `${baseUrl}/complete`,
  },
  direct_pay_quarterly: {
    cost: 42.99,
    priceId: PLANS_CHECKOUT_PRICE_IDS[42.99],
    paddlePriceId: PADDLE_PRICE_IDS.no_trial[42.99],
    coupon: { amount: 60.48, id: COUPON_IDS.percent60, paddleId: PADDLE_DISCOUNT_IDS[60] },
    trial: false,
    cancelUrl: `${baseUrl}/signup/special-offer/plans`,
    successUrl: `${baseUrl}/complete`,
  },
  direct_pay_annual: {
    cost: 99.99,
    priceId: PLANS_CHECKOUT_PRICE_IDS[99.99],
    paddlePriceId: PADDLE_PRICE_IDS.no_trial[99.99],
    coupon: { amount: 50.01, id: COUPON_IDS.percent50, paddleId: PADDLE_DISCOUNT_IDS[50] },
    trial: false,
    cancelUrl: `${baseUrl}/signup/special-offer/plans`,
    successUrl: `${baseUrl}/complete`,
  },
  presidentsdayweb2025: {
    cost: 124.99,
    priceId: DYNAMIC_ANNUAL_PRICE_IDS[124.99].noTrialDescription,
    paddlePriceId: PADDLE_PRICE_IDS.no_trial[124.99],
    coupon: { amount: 40, id: COUPON_IDS.percent40, paddleId: PADDLE_DISCOUNT_IDS[40] },
    trial: false,
    cancelUrl: `${baseUrl}/offer/go`,
    successUrl: `${baseUrl}/subscription/create-account/complete`,
    endDate: new Date("2025-02-18T23:59:59-04:00"),
  },
  appjuly2025: {
    cost: 99.99,
    priceId: DYNAMIC_ANNUAL_PRICE_IDS[99.99].noTrialDescription,
    paddlePriceId: PADDLE_PRICE_IDS.no_trial[99.99],
    coupon: { amount: 40, id: COUPON_IDS.percent40, paddleId: PADDLE_DISCOUNT_IDS[40] },
    trial: false,
    cancelUrl: `${baseUrl}/offer/go`,
    successUrl: `${baseUrl}/subscription/create-account/complete`,
    startDate: new Date("2025-06-30T01:01:00-04:00"),
    endDate: new Date("2025-07-08T23:59:59-04:00"),
  },
  webjuly2025: {
    cost: 124.99,
    priceId: DYNAMIC_ANNUAL_PRICE_IDS[124.99].noTrialDescription,
    paddlePriceId: PADDLE_PRICE_IDS.no_trial[124.99],
    coupon: { amount: 40, id: COUPON_IDS.percent40, paddleId: PADDLE_DISCOUNT_IDS[40] },
    trial: false,
    cancelUrl: `${baseUrl}/offer/go`,
    successUrl: `${baseUrl}/subscription/create-account/complete`,
    startDate: new Date("2025-06-30T01:01:00-04:00"),
    endDate: new Date("2025-07-08T23:59:59-04:00"),
  },
  gift_purchase: {
    cost: 99.99,
    priceId: DYNAMIC_GIFT_PRICE_IDS[99.99],
    trial: false,
    cancelUrl: `${baseUrl}/gift/start`,
    successUrl: `${baseUrl}/gift/complete`,
  },
  gift_redeem: {
    cost: 124.99,
    priceId: DYNAMIC_GIFT_REDEMPTION_PRICE_IDS[124.99],
    trial: false,
    cancelUrl: `${baseUrl}/gift/redeem`,
    successUrl: `${baseUrl}/gift/claim/complete`,
  },
  buddhism: {
    cost: 120,
    priceId: DYNAMIC_ANNUAL_PRICE_IDS[120.00].noTrialDescription,
    trial: false,
    cancelUrl: `${baseUrl}/buddhism/special-offer`,
    successUrl: `${baseUrl}/complete`,
  },
  buddhism_test_route: {
    cost: 1,
    priceId: DYNAMIC_ANNUAL_PRICE_IDS[1].noTrialDescription,
    trial: false,
    cancelUrl: `${baseUrl}/buddhism/special-offer-test`,
    successUrl: `${baseUrl}/complete`,
  },
  default: {
    cost: 124.99,
    priceId: DYNAMIC_ANNUAL_PRICE_IDS[124.99].trialDescription,
    paddlePriceId: PADDLE_PRICE_IDS.trial[124.99],
    coupon: { amount: 20, id: COUPON_IDS.percent20, paddleId: PADDLE_DISCOUNT_IDS[20] },
    trial: true,
    cancelUrl: `${baseUrl}/special-offer`,
    successUrl: `${baseUrl}/special-offer/complete`,
  },
  // google: {
  //   cost: 124.99,
  //   priceId: DYNAMIC_ANNUAL_PRICE_IDS[124.99].trialDescription,
  //   coupon: { amount: 20, id: COUPON_IDS.percent20 },
  //   trial: true,
  //   cancelUrl: `${baseUrl}/special-offer`,
  //   successUrl: `${baseUrl}/special-offer/complete`,
  // },
  // facebook: {
  //   cost: 124.99,
  //   priceId: DYNAMIC_ANNUAL_PRICE_IDS[124.99].trialDescription,
  //   coupon: { amount: 20, id: COUPON_IDS.percent20 },
  //   trial: true,
  //   cancelUrl: `${baseUrl}/special-offer`,
  //   successUrl: `${baseUrl}/special-offer/complete`,
  // },
  // youtube: {
  //   cost: 124.99,
  //   priceId: DYNAMIC_ANNUAL_PRICE_IDS[124.99].trialDescription,
  //   coupon: { amount: 20, id: COUPON_IDS.percent20 },
  //   trial: true,
  //   cancelUrl: `${baseUrl}/special-offer`,
  //   successUrl: `${baseUrl}/special-offer/complete`,
  // },
};

// Maps US prices to other countries.
export const COUNTRY_PRICING_MAP = {
  23.99: {
    US: {
      symbol: "$",
      annual: "23.99",
      monthly: "1.99",
    },
    AU: {
      symbol: "A$",
      annual: "35.99",
      monthly: "2.99",
    },
    CA: {
      symbol: "CA$",
      annual: "31.99",
      monthly: "2.67",
    },
    EU: {
      symbol: "€",
      annual: "21.99",
      monthly: "1.75",
    },
    GB: {
      symbol: "£",
      annual: "17.99",
      monthly: "1.49",
    },
    NZ: {
      symbol: "NZ$",
      annual: "35.99",
      monthly: "2.99",
    },
    CH: {
      symbol: "CHF",
      annual: "18.99",
      monthly: "1.58",
    },
  },
  42.99: {
    US: {
      symbol: "$",
      annual: "42.99",
      monthly: "3.59",
    },
    AU: {
      symbol: "A$",
      annual: "62.99",
      monthly: "5.25",
    },
    CA: {
      symbol: "CA$",
      annual: "52.99",
      monthly: "4.42",
    },
    EU: {
      symbol: "€",
      annual: "37.99",
      monthly: "3.17",
    },
    GB: {
      symbol: "£",
      annual: "29.99",
      monthly: "2.49",
    },
    NZ: {
      symbol: "NZ$",
      annual: "62.99",
      monthly: "5.25",
    },
    CH: {
      symbol: "CHF",
      annual: "33.99",
      monthly: "2.83",
    },
  },
  99.99: {
    US: {
      symbol: "$",
      annual: "99.99",
      monthly: "8.33",
    },
    AU: {
      symbol: "A$",
      annual: "149.99",
      monthly: "12.50",
    },
    CA: {
      symbol: "CA$",
      annual: "124.99",
      monthly: "10.42",
    },
    EU: {
      symbol: "€",
      annual: "89.99",
      monthly: "7.50",
    },
    GB: {
      symbol: "£",
      annual: "69.99",
      monthly: "5.84",
    },
    NZ: {
      symbol: "NZ$",
      annual: "149.99",
      monthly: "12.50",
    },
    CH: {
      symbol: "CHF",
      annual: "79.99",
      monthly: "6.67",
    },
  },
  124.99: {
    US: {
      symbol: "$",
      annual: "124.99",
      monthly: "10.42",
    },
    AU: {
      symbol: "A$",
      annual: "187.49",
      monthly: "15.63",
    },
    CA: {
      symbol: "CA$",
      annual: "156.24",
      monthly: "13.02",
    },
    EU: {
      symbol: "€",
      annual: "112.49",
      monthly: "9.38",
    },
    GB: {
      symbol: "£",
      annual: "87.49",
      monthly: "7.30",
    },
    NZ: {
      symbol: "NZ$",
      annual: "187.49",
      monthly: "15.63",
    },
  },
  120: {
    US: {
      symbol: "$",
      annual: "120.00",
      monthly: "10.00",
    },
    AU: {
      symbol: "A$",
      annual: "181.6092",
      monthly: "15.1341",
    },
    CA: {
      symbol: "CA$",
      annual: "163.4436",
      monthly: "13.6203",
    },
    EU: {
      symbol: "€",
      annual: "101.9869",
      monthly: "8.4989",
    },
    GB: {
      symbol: "£",
      annual: "88.6282",
      monthly: "7.3856",
    },
    NZ: {
      symbol: "NZ$",
      annual: "198.516",
      monthly: "16.543",
    },
  },
  1: {
    US: {
      symbol: "$",
      annual: "1.00",
      monthly: "0.08",
    },
    AU: {
      symbol: "A$",
      annual: "1.5134",
      monthly: "0.1261",
    },
    CA: {
      symbol: "CA$",
      annual: "1.362",
      monthly: "0.1135",
    },
    EU: {
      symbol: "€",
      annual: "0.8499",
      monthly: "0.0708",
    },
    GB: {
      symbol: "£",
      annual: "0.7386",
      monthly: "0.0615",
    },
    NZ: {
      symbol: "NZ$",
      annual: "1.6543",
      monthly: "0.1378",
    },
  },
};
